var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.audio)?_c('Object3D',{attrs:{"obj":_vm.audio}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }